function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4d6c2553\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ba0n6m0pdol!../../../node_modules/string-replace-webpack-plugin/loader.js?id=vjdso5oqwij!./Petition.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ba0n6m0pdol!../../../node_modules/string-replace-webpack-plugin/loader.js?id=vjdso5oqwij!./Petition.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4d6c2553\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ba0n6m0pdol!../../../node_modules/string-replace-webpack-plugin/loader.js?id=vjdso5oqwij!./Petition.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d6c2553",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/Petition.vue
// module id = 263
// module chunks = 0